import React from "react";
import { Grid, Box, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ProcedureSection from "./ProcedureSection";
import CriticalParameters from "./CriticalParameterBox";
import ChatIndex from "./ChatIndex";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "auto",
    // padding: theme.spacing(2),
    boxSizing: "border-box",
  },
  section: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    // overflowY: "auto",
    // maxHeight: "100%", // Max height to allow scrolling
    // borderLeft: "1px solid #ccc", // Divider between sections
  },
  firstSection: {
    //   borderLeft: "none", // Remove left border for the first section
    //   borderRight: "1px solid #ccc",
    },
    divider: {
        height: 'auto',
        alignSelf: 'stretch', // Ensures the divider fills the available height
      },
//   scrollableSection: {
//     overflowY: "auto",
//     maxHeight: "calc(100vh - 50px)", // Adjust based on fixed elements like headers
//   },
}));

const BatchUnitDetails = (props) => {
    const { data, sample, batchData, batchDetails  }= props
    const classes = useStyles();
    return (
        <Grid container className={classes.root}>
      {/* Section 1 */}
      <Grid item xs={sample ? 2: 3}>
        <Box className={`${classes.section} ${classes.firstSection}`}>
        <ProcedureSection data={data} sample={sample} />
        </Box>
      </Grid>

      <Divider orientation="vertical" flexItem className={classes.divider} />
      {/* Section 2 */}
      <Grid item xs={sample ? 7: 6}>
      <Box className={`${classes.section}`}>
      <CriticalParameters data={data} parameters={sample ? data.criticalQualityAttributes :data.criticalProcessParameters} sample={sample} />
        </Box>
      </Grid>

      <Divider orientation="vertical" flexItem className={classes.divider} />
      {/* Section 3 */}
      <Grid item xs={2}>
      <Box className={`${classes.section}`}>
            <ChatIndex unitBatchOperations={true} row={{cdmoOrgID: batchDetails?.vendorMosymphonyID, sponsorOrgID: batchDetails?.brandOwnerMosymphonyID}} file={{collabrixWorkItemID: batchData.collabrixWorkItemID}} collabrixBatchID={batchData.collabrixBatchID} collabrixQCSamplingID={data.collabrixQCSamplingID} collabrixUnitOperationID={data.collabrixUnitOperationID} />
        </Box>
      </Grid>
    </Grid>
    );
}

export default BatchUnitDetails